import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@lib/api';

const AuditLog: React.FC = () => {
  const { data: logsData } = useQuery({
    queryKey: ['audit-log'],
    queryFn: async () => {
      const response = await apiClient.get<any>('/api/audit-log?limit=100');
      return response;
    },
  });

  const logs = logsData?.items || [];

  return (
    <div>
      <h1 className="text-3xl font-bold text-gray-900 mb-8">Audit Log</h1>

      <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
        <table className="w-full">
          <thead className="bg-gray-50 border-b border-gray-200">
            <tr>
              <th className="px-6 py-3 text-left text-sm font-semibold text-gray-900">Actor</th>
              <th className="px-6 py-3 text-left text-sm font-semibold text-gray-900">Action</th>
              <th className="px-6 py-3 text-left text-sm font-semibold text-gray-900">Resource</th>
              <th className="px-6 py-3 text-left text-sm font-semibold text-gray-900">Timestamp</th>
            </tr>
          </thead>
          <tbody>
            {logs.length === 0 ? (
              <tr>
                <td colSpan={4} className="px-6 py-8 text-center text-gray-500">
                  No audit logs yet. Actions will appear here.
                </td>
              </tr>
            ) : (
              logs.map((log: any) => (
                <tr key={log.id} className="border-b border-gray-200 hover:bg-gray-50">
                  <td className="px-6 py-4 text-sm font-medium text-gray-900">{log.actor_email}</td>
                  <td className="px-6 py-4 text-sm">
                    <span className="px-2 py-1 bg-blue-100 text-blue-800 rounded text-xs font-medium">
                      {log.action}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-700">{log.resource_type}</td>
                  <td className="px-6 py-4 text-sm text-gray-500">
                    {new Date(log.created_at * 1000).toLocaleString()}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AuditLog;
